import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/Cover.css';

const images = [
  '/albums/hero/hero1.webp',
  '/albums/hero/photo1.webp',
  '/albums/hero/photo2.webp',
  '/albums/hero/photo3.webp',
  '/albums/hero/photo12.webp',
  '/albums/hero/photo13.webp',
  '/albums/hero/photo32.webp',
  '/albums/hero/photo33.webp',
];

const PrevArrow = ({ onClick }) => (
  <button
    className="custom-arrow custom-prev-arrow"
    onClick={onClick}
    aria-label="Previous slide"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    className="custom-arrow custom-next-arrow"
    onClick={onClick}
    aria-label="Next slide"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </button>
);

/**
 * @param {boolean} embedded - fills HeroVideo pin (no extra 100vh)
 * @param {boolean} active - enables carousel / interactions
 * @param {boolean} showCarousel - photo slider; false = text/CTAs over video end frame only
 */
const Cover = ({ embedded = false, active = true, showCarousel = true }) => {
  const [showWorkDropdown, setShowWorkDropdown] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!active || !showCarousel) return undefined;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [active, showCarousel]);

  useEffect(() => {
    if (active && showCarousel) {
      setCurrentImageIndex(0);
    }
  }, [active, showCarousel]);

  const handleWorkDropdown = () => {
    setShowWorkDropdown((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showWorkDropdown && !event.target.closest('.see-work-container')) {
        setShowWorkDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showWorkDropdown]);

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  useEffect(() => {
    if (!showCarousel) return undefined;
    const currentSrc = images[currentImageIndex];
    const nextSrc = images[(currentImageIndex + 1) % images.length];
    [currentSrc, nextSrc].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [currentImageIndex, showCarousel]);

  return (
    <section
      className={[
        'cover-section',
        embedded ? 'cover-section--embedded' : '',
        !showCarousel ? 'cover-section--text-only' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label="Wedding photography cover"
    >
      {showCarousel && (
        <>
          <div className="hero-slider">
            <div
              className="hero-slide"
              style={{
                height: '100vh',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                backgroundImage: `url(${images[currentImageIndex]})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                transition: 'opacity 0.5s ease-in-out',
                zIndex: 1,
              }}
            />
          </div>

          <div className="cover-arrows">
            <PrevArrow onClick={goToPrev} />
            <NextArrow onClick={goToNext} />
          </div>
        </>
      )}

      <div className="cover-overlay">
        <div className="cover-text">
          <h2>
            We&apos;re not just <span className="dancing-script-cream">Photographers</span>
            <br />
            WE&apos;RE <span className="dancing-script-cream">Storytellers</span>
          </h2>

          <div className="see-work-container">
            <div className="see-work-wrapper">
              <button className="see-work-btn" onClick={handleWorkDropdown}>
                See Our Portfolio
              </button>
              {showWorkDropdown && (
                <div className="see-work-dropdown">
                  <Link
                    to="/photos"
                    className="dropdown-item"
                    onClick={() => setShowWorkDropdown(false)}
                  >
                    Photos
                  </Link>
                  <Link
                    to="/films"
                    className="dropdown-item"
                    onClick={() => setShowWorkDropdown(false)}
                  >
                    Films
                  </Link>
                </div>
              )}
            </div>

            <button className="book-us-btn" onClick={() => navigate('/book')}>
              Book Your Day
            </button>

            <button className="book-us-btn" onClick={() => navigate('/packages')}>
              View Packages
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cover;
